import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

// Nest this in PageContainer for dropdshadow effect
// You can send in a string or an element for the header and footer
// They are not required and will only render if something is passed in
const Card = forwardRef(({ title, styleName, footer, children }, ref) => {
    const t = (title == null || title == undefined) ? "" : <div className="card-header">{title}</div>;
    const f = (footer == null || footer == undefined) ? "" : <div className="card-header">{footer}</div>;

    const style = styleName ? "card " + styleName : "card";

    return (
        <div className={style} ref={ref}>
            {t}
            <div className="card-body">{children}</div>
            {f}
        </div>
    );
});

Card.displayName = 'Card';

Card.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    styleName: PropTypes.string,
    footer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
    ])
};

export default Card;